import React from 'react';
import Element, { CommonProps } from '../Element';

export type DivProps = CommonProps<'div'>;

const Div: React.FunctionComponent<DivProps> = ({ children, ...props }) => {
  return (
    <Element tagName="div" {...props}>
      {children}
    </Element>
  );
};

export default Div;
